import { render, staticRenderFns } from "./EventNews.vue?vue&type=template&id=d492204a"
import script from "./EventNews.vue?vue&type=script&lang=js"
export * from "./EventNews.vue?vue&type=script&lang=js"
import style0 from "./EventNews.vue?vue&type=style&index=0&id=d492204a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
